"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Data = exports.Row = void 0;
const react_1 = __importDefault(require("react"));
const react_2 = require("@chakra-ui/react");
const index_1 = require("../../../../index");
const Row = ({ children, disableBorders = false, ...props }) => (react_1.default.createElement(react_2.Box, { borderBottom: disableBorders ? '1px solid transparent' : '1px solid #E7E5DF', as: 'tr', px: '4px', borderRight: '1px solid transparent', _hover: { bgColor: '#EAF5FF', transition: 'background-color 250ms ease-in-out' }, _active: { bgColor: '#D9EDFF', transition: 'background-color 250ms ease-in-out' }, _focus: {
        boxShadow: 'inset 1px 1px #006CCF',
        borderBottom: '1px solid #006CCF',
        borderRight: '1px solid #006CCF',
    }, tabIndex: 0, ...props }, children));
exports.Row = Row;
const Data = ({ isReversed, width, children, }) => {
    return (react_1.default.createElement(react_2.Box, { width: width ?? undefined, minWidth: width ? undefined : '146px', px: '8px', as: 'td' },
        react_1.default.createElement(react_2.HStack, { flexDir: isReversed ? 'row-reverse' : 'row' },
            react_1.default.createElement(index_1.Text.Contrast, { appearance: 'medium', size: 'xs', as: 'span' }, children))));
};
exports.Data = Data;
